import { useEffect, useRef, useState } from "react";

export default function Artplacer({ artworkUrl, height, title, size, price, artist }) {
  const anchorRef1 = useRef(null);
  const anchorRef2 = useRef(null);
  const [showPlaceholder, setShowPlaceholder] = useState(true);
  const [widgetsLoaded, setWidgetsLoaded] = useState(false);

  useEffect(() => {
    if (!widgetsLoaded) return;
    const arButton = Array.from(document.querySelectorAll('.view-in-room'))
      .find(btn => btn.textContent?.includes('View in AR'));
    if (arButton) {
      arButton.style.background = '#FFD700';
    }
  }, [widgetsLoaded]);

  useEffect(() => {
    if (!document.getElementById("artplacer-widget-script")) {
      const script = document.createElement("script");
      script.src = "https://widget.artplacer.com/js/script.js";
      script.id = "artplacer-widget-script";
      script.async = true;
      document.body.appendChild(script);
    }

    const insertWidget = () => {
      if (window.ArtPlacer && anchorRef1.current && anchorRef2.current) {
        window.ArtPlacer.insert({
          gallery: "121935",
          dimensions_standard: "hxw",
          unit: "cm",
          type: "2",
          resizable: "false",
          frames: "false",
          rotate: "false",
          catalog: "false",
          data_capture_form: "false",
          lang: "en",
          space: "156959",
          additional_spaces: "156839,122826,154631,73859,155338,155633,156959,156205,47768",
          text: "View in a room",
          classname: "view-in-room",
          artwork_url: artworkUrl,
          height: height,
          title: title,
          size: size,
          price: price,
          artist: artist,
          after: `#${anchorRef1.current.id}`,
        });

        window.ArtPlacer.insert({
          gallery: "121935",
          unit: "cm",
          type: "3",
          text: "View in AR",
          resizable: "false",
          frames: "false",
          rotate: "false",
          catalog: "false",
          data_capture_form: "false",
          classname: "view-in-room",
          artwork_url: artworkUrl,
          height,
          title,
          size,
          price,
          artist,
          after: `#${anchorRef1.current.id}`,
        });

        window.ArtPlacer.insert({
          gallery: "121935",
          resizable: "false",
          frames: "false",
          rotate: "false",
          dimensions_standard: "hxw",
          unit: "cm",
          catalog: "false",
          data_capture_form: "false",
          type: "1",
          text: "View in Your room",
          classname: "view-in-room",
          artwork_url: artworkUrl,
          height: height,
          title: title,
          size: size,
          price: price,
          artist: artist,
          after: `#${anchorRef2.current.id}`,
        });
      }
    };

    let observer;
    if (anchorRef1.current && anchorRef2.current) {
      observer = new MutationObserver(() => {
        // Check if all three buttons are present
        const buttons = document.querySelectorAll(".view-in-room");
        if (buttons.length >= 3) {
          setShowPlaceholder(false);
          setWidgetsLoaded(true);
          observer.disconnect();
        }
      });
      observer.observe(anchorRef1.current.parentNode, { childList: true, subtree: true });
      observer.observe(anchorRef2.current.parentNode, { childList: true, subtree: true });
    }

    const interval = setInterval(() => {
      if (window.ArtPlacer) {
        insertWidget();
        clearInterval(interval);
      }
    }, 200);

    return () => clearInterval(interval);
  }, [artworkUrl, height, title, size, price, artist]);

  return (
    <div className="flex flex-col gap-2 w-full items-start">
      <div className="flex flex-row gap-2 artplacer-row w-auto">
        {!widgetsLoaded && (
          <div
            ref={anchorRef1}
            id="artplacer-anchor-1"
            className="w-[10rem]"
            style={{ display: "inline-block" }}
          />
        )}
      </div>
      <div className="flex flex-row gap-2 artplacer-row w-auto">
        {!widgetsLoaded && (
          <div
            ref={anchorRef2}
            id="artplacer-anchor-2"
            className="w-[10rem]"
            style={{ display: "inline-block" }}
          />
        )}
      </div>
      {showPlaceholder && (
        <div className="h-[5.6rem] w-[20rem]" />
      )}
    </div>
  );
}